function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="110" height="110" fill="none" viewBox="0 0 24 24">
      <path
        fill="#0044F0"
        d="M10.083 15.958H3.508c-.832 0-1.508.664-1.508 1.481s.676 1.482 1.508 1.482h6.575c.832 0 1.508-.665 1.508-1.482s-.675-1.481-1.508-1.481M22 6.379c0-.817-.675-1.48-1.507-1.48h-6.575c-.832 0-1.508.663-1.508 1.48s.676 1.48 1.508 1.48h6.575c.832 0 1.507-.663 1.507-1.48"
        opacity="0.4"
      ></path>
      <path
        fill="#0044F0"
        d="M8.878 6.379c0 1.866-1.54 3.38-3.44 3.38C3.54 9.758 2 8.244 2 6.378S3.54 3 5.439 3s3.439 1.513 3.439 3.379M22 17.4c0 1.865-1.54 3.378-3.44 3.378-1.898 0-3.438-1.513-3.438-3.379s1.54-3.38 3.439-3.38S22 15.534 22 17.4"
      ></path>
    </svg>
  );
}

export default Icon;
